import styled from "@emotion/styled"
import Link from "components/Link"

const ListTwelveLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`

export default ListTwelveLink
